import * as React from 'react';
import { UserMenu, Logout, useGetIdentity } from 'react-admin';
import { MenuItem, ListItemIcon, ListItemText, Typography, Divider } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';

// Display-only menu item showing user email
const UserInfoMenuItem = React.forwardRef<HTMLLIElement>((props, ref) => {
    const { identity } = useGetIdentity();
    return (
        <MenuItem
            ref={ref}
            {...props}
            sx={{
                '&:hover': {
                    backgroundColor: 'transparent',
                    cursor: 'default'
                },
                pointerEvents: 'none'
            }}
        >
            <ListItemIcon>
                <PersonIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
                <Typography variant="body2" color="textSecondary">
                    {identity?.email}
                </Typography>
            </ListItemText>
        </MenuItem>
    );
});

// Display-only menu item showing user role
const RoleInfoMenuItem = React.forwardRef<HTMLLIElement>((props, ref) => {
    const { identity } = useGetIdentity();
    return (
        <MenuItem
            ref={ref}
            {...props}
            sx={{
                '&:hover': {
                    backgroundColor: 'transparent',
                    cursor: 'default'
                },
                pointerEvents: 'none'
            }}
        >
            <ListItemIcon>
                <BadgeIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
                <Typography variant="body2" color="textSecondary">
                    {identity?.userRole}
                </Typography>
            </ListItemText>
        </MenuItem>
    );
});

export const CustomUserMenu = () => {
    return (
        <UserMenu>
            <UserInfoMenuItem />
            <RoleInfoMenuItem />
            <Divider />
            <Logout />
        </UserMenu>
    );
};
